import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import H1 from '@base/H1/H1';
import P1 from '@base/P1/P1';
import Logo from '@comp/Logo/Logo';
import AboutUnacademy from '@comp/AboutUnacademy/AboutUnacademy';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import ExamDetails from './ExamDetails/ExamDetails';
import {
  getIsIITJeeRankPredictor,
  getPredictorConfig,
  getExamUIDByGoalUID
} from './utils';

const Wrapper = styled.div`
  padding-bottom: 120px;
  padding-left: 13vw;
  padding-right: 13vw;
  display: flex;
  justify-content: space-between;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(229, 244, 255, 0.44) 100%
  );

  ${({ $isIITJeeRankPredictor }) =>
    $isIITJeeRankPredictor
      ? {
          marginTop: '-70px',
          height: '780px',
          paddingBottom: '0px',
          alignItems: 'center'
        }
      : {}}

  ${mediaQuery.uptoTablet} {
    padding-left: 10vw;
    padding-right: 10vw;
  }

  ${mediaQuery.uptoMobile} {
    ${({ $isIITJeeRankPredictor }) =>
      $isIITJeeRankPredictor
        ? {
            marginTop: 'unset',
            height: 'unset'
          }
        : {}}
    flex-direction: column;
    padding: 0px;
  }
`;

const Header = styled.div`
  height: ${Spacings.SPACING_HEADER}px;
  padding-left: 13vw;
  padding-right: 13vw;
  display: flex;

  ${mediaQuery.uptoTablet} {
    padding-left: 10vw;
    padding-right: 10vw;
  }

  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B};
  }
`;

const Heading = styled(H1)`
  font-size: ${Fonts.LARGE_HEADING};
  margin-top: ${Spacings.SPACING_10B};
  margin-bottom: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H2};
    margin-top: 0px;
    margin-bottom: ${Spacings.SPACING_5B};
  }
`;

const LeftWrapper = styled.div`
  width: 45%;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
  }
`;

const Point = styled(P1)`
  display: flex;
  align-items: center;
  font-size: ${Fonts.LARGE};
  margin-bottom: ${Spacings.SPACING_4B};

  span {
    margin-left: ${Spacings.SPACING_2B};
    font-size: ${Fonts.SMALL};
  }
`;

const MainImage = styled.img`
  height: ${Spacings.SPACING_35B};
  width: ${Spacings.SPACING_35B};

  ${mediaQuery.uptoMobile} {
    float: right;
    height: ${Spacings.SPACING_20B};
    width: ${Spacings.SPACING_20B};
  }
`;

const CheckedImage = styled.img`
  height: ${Spacings.SPACING_4B};
  width: ${Spacings.SPACING_4B};
`;

const RightWrapper = styled.div`
  width: 45%;

  ${mediaQuery.uptoTablet} {
    width: 50%;
  }

  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: 0px;
  }
`;

const RankPredictor = ({ isOfflineRankPredictor }) => {
  const { query } = useRouter();
  const { goalUID, exam_type } = query;

  const examUID = getExamUIDByGoalUID(goalUID);
  const config = getPredictorConfig(examUID, exam_type);
  const isIITJeeRankPredictor = getIsIITJeeRankPredictor(examUID);

  return (
    <>
      <Header>
        <Logo />
      </Header>
      <Wrapper $isIITJeeRankPredictor={isIITJeeRankPredictor}>
        <LeftWrapper>
          <MainImage
            src={getImage('rankpredictor/rank-predictor-logo.svg')}
            alt="rank-main-logo"
          />
          <Heading>{config.title}</Heading>
          {config.points?.map((point, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Point as="h2" key={index}>
              <CheckedImage
                src={getImage('rankpredictor/checked.svg')}
                alt="checked"
              />
              <span>{point}</span>
            </Point>
          ))}
        </LeftWrapper>
        <RightWrapper>
          <ExamDetails isOfflineRankPredictor={isOfflineRankPredictor} />
        </RightWrapper>
      </Wrapper>
      <AboutUnacademy benefits={config.benefits} />
    </>
  );
};

export default RankPredictor;
